export default "__VITE_ASSET__ef208acd__"